import {
  BrandSoftwareCommandOption,
  BrandSoftwareTypeOption,
  ReleaseEnvironmentTypeOption,
} from "./types";

export const brandSoftwareOptions: BrandSoftwareTypeOption[] = [
  { value: "krosskast", label: "KrossKast App" },
  {
    value: "assistant",
    label: "KrossKast Assistant App",
  },
  { value: "player", label: "KrossKast OS" },
];

export const brandSoftwareRestartCommandOptions: BrandSoftwareCommandOption[] =
  [
    { command: "restart_kk_app", type: "krosskast" },
    { command: "restart_assistant_app", type: "assistant" },
    { command: "restart_player", type: "player" },
  ];

export const brandSoftwareUpdateCommandOptions: BrandSoftwareCommandOption[] = [
  { command: "update_kk_app", type: "krosskast" },
  { command: "update_assistant_app", type: "assistant" },
  { command: "update_player", type: "player" },
];

export const brandSoftwareUpdateSettingsCommandOptions: BrandSoftwareCommandOption[] =
  [
    { command: "update_kk_app_meta", type: "krosskast" },
    { command: "update_assistant_app_meta", type: "assistant" },
  ];

/**
 * T24 — Music Scheduler Fleet command names (single source of truth).
 * update_* writes via Confirm only; report_* is a read request sent on open.
 */
export const UPDATE_KK_MUSIC_SCHEDULE_COMMAND = "update_kk_music_schedule" as const;
export const REPORT_KK_MUSIC_SCHEDULE_COMMAND = "report_kk_music_schedule" as const;

export const releaseEnvironmentOptions: ReleaseEnvironmentTypeOption[] = [
  { value: "production", label: "Production" },
  { value: "staging", label: "Staging" },
];

export const releaseVersionInputRules = [
  {
    required: true,
    message: "A version number is required",
  },
  {
    // Matches Player versionName (optionally with krosskast-v / assistant- prefix).
    pattern: /^([A-Za-z]+-v?)?\d{4}\.\d{1,2}\.\d{1,2}\.\d$/,
    message:
      "Version must be year.month.day.patch (e.g. 2026.10.1.4 or krosskast-v2026.10.1.4)",
  },
];

export const RELEASE_NOTES_MAX_LENGTH = 1000;

export const releaseNotesInputRules = [
  {
    required: true,
    message: "Release notes are required",
  },
  {
    max: RELEASE_NOTES_MAX_LENGTH,
    message: `Release notes must be ${RELEASE_NOTES_MAX_LENGTH} characters or fewer`,
  },
];

export const releaseFileNameInputRules = [
  {
    required: true,
    message: "A valid APK is required",
  },
];

export const releaseTypeMaxBytes = {
  krosskast: 300,
  assistant: 50,
  player: 0,
};
